import { Injectable, OnDestroy } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, Subscription } from "rxjs";

import { environment } from "@environments/environment";
import { User } from "@app/shared/models";
import { Credentials } from "../models/credentials";

import { Store } from "@ngrx/store";
import { AppState } from "../../store/index";
import { AuthState } from "../../store/auth/auth.state";
import * as loggedActions from "../../store/auth/auth.actions";

@Injectable({ providedIn: "root" })
export class AuthenticationService implements OnDestroy {
    initialized: boolean;

    loggedUser$: Observable<AuthState>;
    authdata: string;
    token: string;
    logged: boolean;
    user: User;

    private suscriptionsToManage$: Subscription[] = [];

    constructor(
        private http: HttpClient,
        private store: Store<AppState>,
    ) {
        this.initialized = false;
        this.logged = false;
        this.token = this.getToken();

        this.initSuscriptions();
    }

    initSuscriptions() {
        this.suscriptionsToManage$.push(
            this.store
                .select((state) => state.auth.user)
                .subscribe((res) => {
                    this.user = res;
                }),
        );
    }

    ngOnDestroy() {
        this.suscriptionsToManage$.forEach((subscription) =>
            subscription.unsubscribe(),
        );
    }

    public get authData(): string {
        return this.authdata;
    }

    public get authToken(): string {
        return this.token;
    }

    public isLogged(): boolean {
        if (!this.initialized) {
            this.initAutoLogin();
        }

        const token = this.getToken();
        return token ? true : false;
    }

    public initAutoLogin(): void {
        let token = sessionStorage.getItem("authToken");

        if (token && token.length < 10) {
            token = "";
        }

        if (!token) {
            this.store.dispatch(new loggedActions.InitApp());
        } else {
            this.store.dispatch(new loggedActions.AutoLogin());
        }

        this.initialized = true;
    }

    autoLogin() {
        return this.http.get<User>(`${environment.apiUrl}/user`);
    }

    login(credentials: Credentials) {
        const user = credentials.user;
        const password = credentials.password;

        return this.http.post<any>(`${environment.apiUrl}/auth`, {
            user,
            password,
        });
    }

    logout() {
        // El cierre de sesión se gestiona actualmente desde el store.
    }

    getUser() {
        return this.http.get<any>(`${environment.apiUrl}/user`);
    }

    getToken(): string {
        return sessionStorage.getItem("authToken");
    }

    deleteToken(): void {
        this.token = null;
        sessionStorage.removeItem("authToken");
    }

    deleteUser(): void {
        sessionStorage.removeItem("user");
    }

    /**
     * Guarda el token de autenticación en sessionStorage.
     */
    saveToken(authToken: string): void {
        this.token = authToken;
        sessionStorage.setItem("authToken", authToken);
    }
}
